import { currentInstagramAccountAtom } from '@/atoms/connectedAccounts'
import { NoPosts } from '@/components/home/NoPosts'
import { PostsLoading } from '@/components/home/PostsLoading'
import { ReviewPosts } from '@/components/home/ReviewPosts'
import { ConnectInstagramWarning } from '@/components/ConnectInstagramWarning'
import { useGetGenerationStatus } from '@/hooks/posts/useGetGenerationStatus'
import { useGetPendingPosts } from '@/hooks/useGetPendingPosts'
import { createFileRoute } from '@tanstack/react-router'
import { useAtomValue } from 'jotai'
import { useEffect, useRef } from 'react'
import { ConnectedAccount } from '@/schemas/ConnectedAccount'

export const Route = createFileRoute('/_app/create')({
  component: Index,
})

function Index() {
  const { posts, refetch } = useGetPendingPosts()
  const { generationStatus, getGenerationStatus } = useGetGenerationStatus()
  const connectedAccount: ConnectedAccount | null = useAtomValue(currentInstagramAccountAtom)
  const isReviewingPosts = useRef(false)

  useEffect(() => {
    if (!generationStatus || isReviewingPosts.current) return

    if (generationStatus.hasPostsReadyForReview && !generationStatus.isGenerating) {
      isReviewingPosts.current = true
      refetch()
    }
  }, [generationStatus, refetch])

  useEffect(() => {
    if (isReviewingPosts.current && posts.length === 0) {
      isReviewingPosts.current = false
    }
  }, [posts])

  if (!connectedAccount) {
    return <ConnectInstagramWarning description="Link Instagram to create posts" />
  }

  if (generationStatus?.isGenerating) {
    return <PostsLoading />
  }

  if (generationStatus?.hasPostsReadyForReview && posts.length > 0) {
    return <ReviewPosts posts={posts} onReviewComplete={refetch} />
  }

  return <NoPosts onGenerateMorePosts={getGenerationStatus} />
}
